import { vm } from "../../main.js";
import * as https from "@/components/tools/request/https.js";
import { Loading } from "element-ui";

const NUM_CN = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
export default {
  formatISODate(isoString) {
    if (!isoString) return null;

    try {
      const date = new Date(isoString);
      // 检查是否为有效日期
      if (isNaN(date.getTime())) return null;

      // 转换为本地时间并格式化（示例格式：2025-08-25 14:40:00）
      return new Intl.DateTimeFormat("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      }).format(date);
    } catch (error) {
      console.error("日期格式化失败:", error);
      return null;
    }
  },
  // 获取当前年份
  getYear() {
    let d = new Date();
    return d.getFullYear() + "";
  }, // yyyy-mm-dd hh:mi:ss
  formatDate(time) {
    let d = new Date(parseInt(time));
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    month = month > 9 ? "" + month : "0" + month;
    let day = d.getDate();
    day = day > 9 ? "" + day : "0" + day;
    let hour = d.getHours();
    hour = hour > 9 ? "" + hour : "0" + hour;
    let min = d.getMinutes();
    min = min > 9 ? "" + min : "0" + min;
    let sec = d.getSeconds();
    sec = sec > 9 ? "" + sec : "0" + sec;
    return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
  }, // yyyy-mm-dd hh:mi
  formatDateYMDHMi(time) {
    let d = new Date(parseInt(time));
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    month = month > 9 ? "" + month : "0" + month;
    let day = d.getDate();
    day = day > 9 ? "" + day : "0" + day;
    let hour = d.getHours();
    hour = hour > 9 ? "" + hour : "0" + hour;
    let min = d.getMinutes();
    min = min > 9 ? "" + min : "0" + min;
    return year + "-" + month + "-" + day + " " + hour + ":" + min;
  }, // yyyy-mm-dd
  formatDateYMD(time) {
    let d = new Date(parseInt(time));
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    month = month > 9 ? "" + month : "0" + month;
    let day = d.getDate();
    day = day > 9 ? "" + day : "0" + day;
    return year + "-" + month + "-" + day;
  },
  formatDateMin(time) {
    let d = new Date(parseInt(time));
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    month = month > 9 ? "" + month : "0" + month;
    let day = d.getDate();
    day = day > 9 ? "" + day : "0" + day;
    let hour = d.getHours();
    hour = hour > 9 ? "" + hour : "0" + hour;
    let min = d.getMinutes();
    min = min > 9 ? "" + min : "0" + min;
    return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + "00";
  }, // 判断是否整数
  isInt(val) {
    let r = /^\+?[1-9][0-9]*$/;
    return r.test(val);
  }, // 判断数组是否空数组L
  isEmptyArray(param) {
    return typeof param == "undefined" || param == null || param.length == 0;
  },
  isNotEmptyArray(param) {
    return typeof param != "undefined" || param != null || param.length != 0;
  },
  // 判断对象NULL
  isNull(param) {
    return typeof param == "undefined" || param == null;
  }, // 判断对象非NULL
  isNotNull(param) {
    return typeof param != "undefined" && param != null;
  }, // 判断字符串Empty
  isEmpty(param) {
    return (
      typeof param === "undefined" ||
      param === null ||
      param === "" ||
      param.length == 0
    );
  }, // 判断字符串非Empty
  isNotEmpty(param) {
    return (
      typeof param != "undefined" &&
      param != null &&
      param != "" &&
      param.length > 0
    );
  }, // 消息弹出框
  notifySuccess(msg) {
    vm.$notify({
      message: msg,
      type: "success",
      position: "top-left",
      duration: 2000
    });
  }, // 消息弹出框
  notifySuccessD000103(msg) {
    vm.$notify({
      message: msg,
      position: "top-left",
      duration: 20000,
      dangerouslyUseHTMLString: true
    });
  },
  notifyWarning(msg) {
    vm.$notify({
      message: msg,
      type: "warning",
      position: "top-left",
      duration: 2000
    });
  },
  notifyInfo(msg) {
    vm.$notify({
      message: msg,
      type: "info",
      position: "top-left",
      duration: 2000
    });
  },
  notifyError(msg, duration) {
    if (!this.isInt(duration)) {
      duration = 2000;
    }
    vm.$notify({
      message: msg,
      type: "error",
      position: "top-left",
      duration: duration
    });
  }, // 添加错误消息
  addValidErrMsg(fieldName, msg) {
    vm.$validator.errors.add({ field: fieldName, msg: msg, scope: null });
  }, // 消息确认框
  confirm(msg, okFunc) {
    vm.$confirm(msg, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(() => {
        okFunc();
      })
      .catch(() => {});
  }, // 文件播放路径
  getPlayPath(path) {
    return https.BASEURL + path;
  }, // 判断数组是否包含 ，包含返回index, 不包含返回-1
  contains(arr, obj) {
    return arr.indexOf(obj);
  }, // 请求是否成功
  requestSuccess(res) {
    return res && res.code == "1";
  }, // 获取UUID, 不指定参数时，默认返回32位字符串
  uuid(len, radix) {
    if (!len) len = 32;
    if (!radix) radix = 16;
    var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
      ""
    );
    var uuid = [],
      i;
    radix = radix || chars.length;
    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
      var r;
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
      uuid[14] = "4";
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16);
          uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join("");
  },
  /**
   * 格式化小数
   * @param val 小数
   * @param digits 保留的位数。默认为2位
   */ formatDecimal(val, digits = 2) {
    // let result = parseFloat(val);
    //
    // let multi = '';
    // while (multi.length < digits) {
    //     multi += '0';
    // }
    // multi = '1' + multi;

    return parseFloat(val).toFixed(digits);
  },
  /**
   * 移除数组中的某个值
   * @param list 数组
   * @param val 移除的值
   */ removeOneFromArr(list, val) {
    for (var index in list) {
      if (val == list[index]) {
        list.splice(index, 1);
        return;
      }
    }
  },
  /**
   * 比较两个数值大小
   * @param list 数组
   * @param val 移除的值
   * @return 1: val1>val2,0:val1==val2,-1:val1<val2
   */ compareTo(val1, val2) {
    val1 = Number(this.isEmpty(val1) ? 0 : val1);
    val2 = Number(this.isEmpty(val2) ? 0 : val2);
    if (val1 > val2) {
      return 1;
    } else if (val1 == val2) {
      return 0;
    } else {
      return -1;
    }
  },
  /**
   * 四舍五入，并固定小数位数
   * @param val 小数
   * @param digits 保留的位数。默认为2位
   */ formatMoney(val, digits = 2) {
    let multi = "";
    while (multi.length < digits) {
      multi += "0";
    }
    multi = "1" + multi;

    let result = Math.round(val * multi) / multi + "";
    if (result.indexOf(".") == -1) {
      result += ".";
    }

    let digitNum = result.substring(result.indexOf(".") + 1);
    while (digitNum.length < digits) {
      result += "0";
      digitNum = result.substring(result.indexOf(".") + 1);
    }
    return result;
  },
  /**
   * 四舍五入，不到小数点，到分为止
   * @param val 金额
   */ formatMoneyWithoutDigits(val) {
    return Math.round(val * 100);
  }, // 小写金额转大写金额
  toBigMoney(n) {
    let fraction = ["角", "分"];
    let unit = [
      ["元", "万", "亿"],
      ["", "拾", "佰", "仟"]
    ];
    let head = n < 0 ? "欠" : "";
    n = Math.abs(n);
    let s = "";
    for (let i = 0, j = fraction.length; i < j; i++) {
      s += (
        NUM_CN[
          Math.floor(
            (Math.floor(n * 1000 * 10 * Math.pow(10, i)) % (10 * 1000)) / 1000
          )
        ] + fraction[i]
      ).replace(/零./, "");
    }
    s = s || "整";
    n = Math.floor(n);
    for (let i = 0; i < unit[0].length && n > 0; i++) {
      let p = "";
      for (let j = 0; j < unit[1].length && n > 0; j++) {
        p = NUM_CN[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
    }
    return (
      head +
      s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整")
    );
  },
  toChineseMoney(money, cnIntLast, cnInteger) {
    cnIntLast =
      typeof cnIntLast == "undefined" || cnIntLast == null ? "元" : cnIntLast; //整型完以后的单位
    cnInteger =
      typeof cnInteger == "undefined" || cnInteger == null ? "整" : cnInteger; //整数金额时后面跟的字符
    // console.log(cnIntLast);
    // console.log(cnInteger);
    let cnNums = new Array(
      "零",
      "壹",
      "贰",
      "叁",
      "肆",
      "伍",
      "陆",
      "柒",
      "捌",
      "玖"
    ); //汉字的数字
    let cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
    let cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
    let cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位

    let maxNum = 999999999999999.9999; //最大处理的数字

    let IntegerNum; //金额整数部分
    let DecimalNum; //金额小数部分
    let ChineseStr = ""; //输出的中文金额字符串
    let parts; //分离金额后用的数组，预定义
    if (typeof money == "undefined" || money == null || money === "") {
      return "";
    }
    money = parseFloat(money);
    if (money >= maxNum) {
      console.error("超出最大处理数字");
      return "";
    }
    if (money == 0) {
      ChineseStr = cnNums[0] + cnIntLast + cnInteger;
      return ChineseStr;
    }
    money = money.toString(); //转换为字符串
    if (money.indexOf(".") == -1) {
      IntegerNum = money;
      DecimalNum = "";
    } else {
      parts = money.split(".");
      IntegerNum = parts[0];
      DecimalNum = parts[1].substr(0, 4);
    }
    let n, p, q, m;
    if (parseInt(IntegerNum, 10) > 0) {
      //获取整型部分转换
      var zeroCount = 0;
      var IntLen = IntegerNum.length;
      for (let i = 0; i < IntLen; i++) {
        n = IntegerNum.substr(i, 1);
        p = IntLen - i - 1;
        q = p / 4;
        m = p % 4;
        if (n == "0") {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            ChineseStr += cnNums[0];
          }
          zeroCount = 0; //归零
          ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
        if (m == 0 && zeroCount < 4) {
          ChineseStr += cnIntUnits[q];
        }
      }
      ChineseStr += cnIntLast;
      //整型部分处理完毕
    }
    if (DecimalNum != "") {
      //小数部分
      decLen = DecimalNum.length;
      for (let i = 0; i < decLen; i++) {
        n = DecimalNum.substr(i, 1);
        if (n != "0") {
          ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
        }
      }
    }
    if (ChineseStr == "") {
      ChineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (DecimalNum == "") {
      ChineseStr += cnInteger;
    }
    return ChineseStr;
  }, // 返回金额汉字
  getMoneyCn(n) {
    return NUM_CN[n];
  },
  getDefaultValue(val, def, unit) {
    def = this.isEmpty(def) ? "--" : def;
    unit = this.isEmpty(unit) ? "" : unit;
    return this.isEmpty(val) ? def : val + unit;
  },
  padLeftZero(str) {
    return ("00" + str).substr(str.length);
  },
  formatDateObj(date, fmt) {
    fmt = this.isNull(fmt) ? "yyyy-MM-dd hh:mm" : fmt;
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }
    return fmt;
  },
  /**
   * 时间转换
   * @param time 秒数
   */ formatTime(time) {
    console.log("formatTime>>>" + time);
    if (isNaN(time)) {
      return "--";
    }
    let seconds = parseInt(time); // 总共多少秒

    // 时
    let hour = parseInt(seconds / 3600);
    // 分
    let min = parseInt((seconds % 3600) / 60) + "";
    // 秒
    let second = parseInt((seconds % 3600) % 60) + "";

    let res = "";
    if (hour > 0) {
      hour = hour.length >= 2 ? hour : "0" + hour;
      res = res + hour + ":";
    }
    //if(min>0){
    min = min.length >= 2 ? min : "0" + min;
    res = res + min + ":";
    //}
    if (second > 0) {
      second = second.length >= 2 ? second : "0" + second;
      res = res + second;
    }
    return res;
  },
  /**
   * 以str结尾
   */ endWith(str, endStr) {
    let d = str.length - endStr.length;
    return d >= 0 && str.lastIndexOf(endStr) == d;
  }, // 屏幕适配计算
  resizeScreen() {
    // 设计尺寸
    let designSize = 1920;
    // 窗口宽度
    let wW = document.documentElement.clientWidth;
    let rem = (wW * 100) / designSize;
    document.documentElement.style.fontSize = rem + "px";
  }, // 移除屏幕适配
  clearScreenFontSize() {
    document.documentElement.removeAttribute("style");
  },
  subString(str, length) {
    if (str.length > length) {
      return str.substring(0, length) + "...";
    }
    return str;
  },
  /**
   * 时间转换
   * @param time 秒数
   */ formatTimeToMin(time) {
    if (time == null || time == 0) {
      return "0 s";
    }
    let seconds = parseInt(time); // 总共多少秒

    // 时
    let hour = parseInt(seconds / 3600);
    // 分
    let min = parseInt((seconds % 3600) / 60) + "";
    // 秒
    let second = parseInt((seconds % 3600) % 60) + "";

    let res = "";
    if (hour > 0) {
      res = res + hour + "h";
    }
    if (res.length > 0) {
      res = res + min + "min";
    } else if (min > 0) {
      res = res + min + "min";
    }
    if (second > 0) {
      res = res + second + "s";
    }
    return res;
  },

  // 请求成功回掉
  isSuccess(res, callBack) {
    if (res && res.code === "1") {
      callBack();
    }
  },

  // 获取资源的全路径
  getResPath(path) {
    return consts.SYS_CONTEXT_PATH + path;
  },

  showLoading(options) {
    return Loading.service({
      text: "加载中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
      ...options
    });
  },

  closeLoading() {
    this.showLoading().close();
  },

  //校验手机号
  validatePhoneNumber(str) {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    return reg.test(str);
  },

  /**
   * 时间转换
   * @param time 秒数
   */ formatTime2(time) {
    if (isNaN(time)) {
      return "--";
    }
    let seconds = parseInt(time); // 总共多少秒

    // 时
    let hour = parseInt(seconds / 3600);
    // 分
    let min = parseInt((seconds % 3600) / 60) + "";
    // 秒
    let second = parseInt((seconds % 3600) % 60) + "";

    let res = "";
    if (hour >= 0) {
      hour = hour.length >= 2 ? hour : "0" + hour;
      res = res + hour + ":";
    }
    if (min >= 0) {
      min = min.length >= 2 ? min : "0" + min;
      res = res + min + ":";
    }
    if (second >= 0) {
      second = second.length >= 2 ? second : "0" + second;
      res = res + second;
    }
    return res;
  }
};



// WEBPACK FOOTER //
// ./src/components/tools/utils.js